// A submission id carries the sandbox configuration it ran with, e.g.
// "6ab0ade1...win10vpnfull_triage" means Windows 10, VPN traffic, full triage.
// The id itself is never worth showing, but these three tags are what tell two
// analyses of the same file apart.

const MACHINES = [
  ["win7", "Windows 7"],
  ["win10", "Windows 10"],
  ["win11", "Windows 11"],
  ["linux22", "Linux"],
  ["macos16", "MacOS"],
  ["andro13", "Android 13"],
];

const NETWORK_MODES = [
  ["internet", "Internet"],
  ["vpn", "VPN"],
  ["simulate", "Simulated"],
  ["disable", "No Network"],
];

const ANALYSIS_TYPES = [
  ["full_triage", "Full Triage"],
  ["high_evasion", "High Evasion"],
  ["basic_evasion", "Basic Evasion"],
];

const matchTag = (id, table) => {
  const found = table.find(([token]) => id.includes(token));

  return found ? found[1] : "";
};

export const getSubmissionTags = (submissionID) => {
  const id = typeof submissionID === "string" ? submissionID : "";

  return {
    machine: matchTag(id, MACHINES),
    network: matchTag(id, NETWORK_MODES),
    analysisType: matchTag(id, ANALYSIS_TYPES),
  };
};

// "2026/09/21  (04:09:05)" -> { date: "2026/09/21", time: "04:09" }
export const splitRunTime = (runTime) => {
  if (typeof runTime !== "string" || !runTime.trim()) return { date: "", time: "" };

  const match = runTime.match(/^\s*(\S+)\s*\(?\s*(\d{2}:\d{2})(?::\d{2})?\s*\)?\s*$/);

  if (!match) return { date: runTime.replace(/\s+/g, " ").trim(), time: "" };

  return { date: match[1], time: match[2] };
};

export const getSeverityLabel = (decision) => {
  if (decision === 0) return "not suspicious";
  if (decision === 1) return "suspicious";
  if (decision === 2) return "malicious";

  return "loading";
};

export default getSubmissionTags;
